import React from 'react';
import { GlassCard } from '../components/GlassCard';
import { UserIcon, CameraIcon, EditIcon } from 'lucide-react';
export function Profile() {
  // Mock user data
  const user = {
    name: 'Finn',
    username: '@finnbags',
    bio: 'Digital creator | AURA enthusiast',
    joinDate: 'May 2023',
    completedChallenges: 28,
    auraBalance: 450000
  };
  // Mock achievement data
  const achievements = [{
    id: '1',
    title: 'Early Adopter',
    description: 'Joined AURA in the first month',
    icon: '🌟'
  }, {
    id: '2',
    title: 'Challenge Master',
    description: 'Completed 25+ brand challenges',
    icon: '🏆'
  }, {
    id: '3',
    title: 'Trendsetter',
    description: 'Started a challenge that 1000+ users joined',
    icon: '🔥'
  }];
  return <div className="space-y-6 pb-4 pt-4 px-4" data-id="element-163">
      <h1 className="text-xl font-bold text-gray-900" data-id="element-164">Profile</h1>
      {/* Profile header - fixed spacing */}
      <div className="relative mt-8" data-id="element-165">
        <GlassCard className="bg-gradient-to-r from-blue-50 to-white/90 pt-14 pb-5 px-4" data-id="element-166">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-167">
            <div className="relative" data-id="element-168">
              <div className="w-24 h-24 rounded-full bg-gradient-to-b from-blue-100 to-white flex items-center justify-center border-4 border-white" data-id="element-169">
                <UserIcon size={48} className="text-blue-400" data-id="element-170" />
              </div>
              <button className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center border-2 border-white" data-id="element-171">
                <CameraIcon size={14} className="text-white" data-id="element-172" />
              </button>
            </div>
          </div>
          <div className="text-center" data-id="element-173">
            <div className="flex items-center justify-center" data-id="element-174">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-175">{user.name}</h2>
              <button className="ml-2 text-gray-400" data-id="element-176">
                <EditIcon size={14} data-id="element-177" />
              </button>
            </div>
            <p className="text-blue-500 font-medium text-sm" data-id="element-178">{user.username}</p>
            <p className="text-gray-500 text-sm mt-2 max-w-xs mx-auto" data-id="element-179">
              {user.bio}
            </p>
            <div className="flex justify-center space-x-6 mt-4" data-id="element-180">
              <div className="text-center" data-id="element-181">
                <p className="text-gray-500 text-xs" data-id="element-182">Joined</p>
                <p className="font-medium text-gray-800" data-id="element-183">{user.joinDate}</p>
              </div>
              <div className="text-center" data-id="element-184">
                <p className="text-gray-500 text-xs" data-id="element-185">Challenges</p>
                <p className="font-medium text-gray-800" data-id="element-186">
                  {user.completedChallenges}
                </p>
              </div>
              <div className="text-center" data-id="element-187">
                <p className="text-gray-500 text-xs" data-id="element-188">Balance</p>
                <p className="font-medium text-gray-800" data-id="element-189">
                  {user.auraBalance.toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </GlassCard>
      </div>
      {/* Achievements - consistent spacing */}
      <div data-id="element-190">
        <h2 className="text-lg font-bold text-gray-900 mb-3" data-id="element-191">Achievements</h2>
        <div className="space-y-3" data-id="element-192">
          {achievements.map(achievement => <GlassCard key={achievement.id} className="p-4" data-id="element-193">
              <div className="flex items-center" data-id="element-194">
                <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-xl" data-id="element-195">
                  {achievement.icon}
                </div>
                <div className="ml-4" data-id="element-196">
                  <h3 className="font-medium text-gray-900" data-id="element-197">
                    {achievement.title}
                  </h3>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-198">
                    {achievement.description}
                  </p>
                </div>
              </div>
            </GlassCard>)}
        </div>
      </div>
    </div>;
}